import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  Typography,
} from '@growdash/design-system/atoms';

import { useOnboarding } from '@growdash/growintel/hooks/useOnboarding';

export default function SearchOnboardingDialog() {
  const { markAsOnboarded, isOnboarded } = useOnboarding('search');
  if (isOnboarded) return null;

  return (
    <Dialog
      defaultOpen
      onOpenChange={(open) => {
        if (!open) {
          markAsOnboarded();
        }
      }}
    >
      <DialogContent className="min-w-fit text-center px-36">
        <Typography className="font-bold text-2xl">
          Search any brand, branch, or menu item.
        </Typography>
        <Typography className="text-sm mt-6">
          Get instant insights on pricing, ratings, and delivery times in your
          area.
        </Typography>
        <Typography className="text-sm mt-1">
          <strong>Save your faves to your watchlist for quicker access.</strong>
        </Typography>
        <div className="mt-10">
          <DialogClose onClick={markAsOnboarded}>
            <Button>Start exploring</Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
}
